import React from 'react';
import { WorkshopResource } from '../../services/meetingService';
import styles from '../../styles/workshop2026Page.module.css';

interface WorkshopResourcesSectionProps {
  resources: WorkshopResource[];
}

const WorkshopResourcesSection: React.FC<WorkshopResourcesSectionProps> = ({ resources }) => {
  if (!resources.length) {
    return (
      <p className={styles.helperText}>No workshop resources have been added yet.</p>
    );
  }

  return (
    <ul className={styles.workshopResourceList}>
      {resources.map((resource) => {
        const external = /^https?:\/\//i.test(resource.url);
        return (
          <li key={resource.id} className={styles.workshopResourceItem}>
            <a
              href={resource.url}
              className={styles.workshopResourceLink}
              {...(external
                ? { target: '_blank', rel: 'noopener noreferrer' }
                : {})}
            >
              {resource.title}
            </a>
            {resource.description?.trim() ? (
              <p className={styles.workshopResourceDesc}>{resource.description.trim()}</p>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
};

export default WorkshopResourcesSection;
